import { render, staticRenderFns } from "./ImportacaoTabelaPrecos.vue?vue&type=template&id=dac1ebb8&scoped=true&"
import script from "./ImportacaoTabelaPrecos.vue?vue&type=script&lang=js&"
export * from "./ImportacaoTabelaPrecos.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoTabelaPrecos.vue?vue&type=style&index=0&id=dac1ebb8&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac1ebb8",
  null
  
)

export default component.exports